import type { SomnologyOrganizationType } from '../../../../../common/enums/SomnologyOrganizationType';
import { ResponsiveCard } from '../../molecules/card/Card';

interface IDeprecatedOsasFaqCardProps {
    lg?: number;
    returnTo?: string;
    somnologyOrganizationType?: SomnologyOrganizationType;
}

/**
 * @deprecated This component should be phased out with the old OSAS carepath
 */
export function DeprecatedOsasFaqCard(props: Readonly<IDeprecatedOsasFaqCardProps>) {
    let linkTo = `/osasFaqPage?somnologyOrganizationType=${props.somnologyOrganizationType}`;

    if (props.returnTo) {
        linkTo += '&returnTo=' + props.returnTo;
    }

    return (
        <ResponsiveCard
            body="Heb je een vraag? Zie hier de antwoorden op veelgestelde vragen."
            cardTitle="Veelgestelde vragen"
            icon="question"
            lg={props.lg}
            linksText={['Lees verder']}
            linksTo={[linkTo]}
        />
    );
}
